import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';

import {
  Date,
  DateField,
  RemoteAutoCompleteField,
  RemoteAutoComplete,
  InputField,
  Input,
  CheckboxField,
  Checkbox
} from '@components/form';

const View: React.SFC<any> = () => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={12}>
          <DateField component={Date} id="reportedDate" name="reportedDate" label="Hlášeno" />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <RemoteAutoCompleteField
            component={RemoteAutoComplete}
            id="reason"
            name="reason"
            label="Důvod pátrání"
            url="/metropolis/api/wp/reasons"
            fullWidth={true}
            labelFunction={o => get(o, 'name')}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InputField component={Input} id="note" name="note" label="Poznámka" />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <CheckboxField component={Checkbox} id="found" name="found" label="Nalezen" />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
  </div>
);

export const WantedPersonsFormSearch = View;



// WEBPACK FOOTER //
// ./src/modules/wantedPersons/WantedPersonsFormSearch.tsx